import { useState, useEffect, useCallback } from 'react';
import { getCurations } from '../api/curationService';
import { Curation } from '../types/curation';
import { useAddress } from '../contexts/AddressContext';
import { DEFAULT_COORDINATES } from '../config/constants';

/**
 * 큐레이션 데이터를 가져오는 커스텀 훅
 */
export const useCurations = () => {
  const [curations, setCurations] = useState<Curation[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { address } = useAddress();

  const fetchCurations = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      // 주소 컨텍스트에서 좌표 정보 가져오기, 없으면 기본 좌표 사용
      const coordinates = {
        lat: address?.lat ?? DEFAULT_COORDINATES.lat,
        lng: address?.lng ?? DEFAULT_COORDINATES.lng
      };
      
      const data = await getCurations(coordinates.lat, coordinates.lng);
      
      // 빈 결과가 아닌 큐레이션만 필터링
      const validCurations = data.curationResults.allResults.filter(
        curation => !curation.isEmpty && curation.stores.length > 0
      );
      
      setCurations(validCurations);
    } catch (err) {
      console.error('Failed to fetch curations:', err);
      setError('큐레이션을 불러오는데 실패했습니다.');
      setCurations([]);
    } finally {
      setLoading(false);
    }
  }, [address]);

  useEffect(() => {
    fetchCurations();
  }, [fetchCurations]);

  return { curations, loading, error, refetch: fetchCurations };
}; 